/**
 * [resp-img]
 * responsive images via data-resp-img-* attributes
 */
window.coma = window.coma || {};

window.coma.typo3Workarounds = (function ($, undefined) {

    // PRIVATE FUNCTIONS
    var _private = {

        init: function() {
            _private.removeClassesToOlListItemsWithinHighlight();
        },
        removeClassesToOlListItemsWithinHighlight: function() {
            // it is not possible to remove classes to <li> elements within
            // the .highlight box with the rte editor, so we remove them here
            $('.highlight').find('ol>li').removeClass();
        }
    }

    // CALL INIT
    $(document).ready(function() {
        _private.init();
    });

    // PUBLIC FUNCTIONS
    return {}

}(jQuery));